import { motion } from "framer-motion";
import { Flower2, Zap, Crown } from "lucide-react";
import { Eyebrow, Reveal, EASE } from "./Reveal";

const AUDIENCES = [
    {
        icon: Flower2,
        title: "SERIOUS YOGIS",
        desc: "For practitioners who want to take their yogasana practice to an advanced level.",
    },
    {
        icon: Zap,
        title: "ATHLETES",
        desc: "For athletes preparing for competitive yogasana performance.",
    },
    {
        icon: Crown,
        title: "FUTURE CHAMPIONS",
        desc: "For ambitious practitioners preparing for tournaments and championship-level performance.",
    },
];

export default function Audience() {
    return (
        <section data-testid="audience-section" className="relative bg-[#0A0A0A] py-20 sm:py-28 lg:py-32">
            <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow center>Who Is This For</Eyebrow>
                <Reveal>
                    <h2 className="mt-6 text-center font-display text-3xl leading-tight tracking-wide sm:text-4xl lg:text-5xl">
                        FOR SERIOUS YOGIS <span className="text-[#D4A017]">|</span> ATHLETES{" "}
                        <span className="text-[#D4A017]">|</span>{" "}
                        <span className="text-gold-grad">FUTURE CHAMPIONS</span>
                    </h2>
                </Reveal>

                <div className="mt-14 grid gap-6 md:grid-cols-3">
                    {AUDIENCES.map((a, i) => {
                        const Icon = a.icon;
                        return (
                            <motion.div
                                key={a.title}
                                data-testid="audience-card"
                                className="group relative rounded-2xl border border-white/[0.07] bg-gradient-to-b from-white/[0.04] to-transparent p-9 text-center transition-all duration-500 hover:-translate-y-2 hover:border-[#D4A017]/45 hover:shadow-[0_20px_55px_-22px_rgba(212,160,23,0.35)]"
                                initial={{ opacity: 0, y: 36 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.25 }}
                                transition={{ duration: 0.75, delay: i * 0.12, ease: EASE }}
                            >
                                <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-[#D4A017]/45 bg-[#D4A017]/[0.07] transition-all duration-500 group-hover:border-[#F5C542] group-hover:shadow-[0_0_28px_rgba(245,197,66,0.35)]">
                                    <Icon size={24} className="text-[#F5C542]" />
                                </span>
                                <h3 className="mt-7 font-display text-3xl tracking-[0.1em] text-white">
                                    {a.title}
                                </h3>
                                <p className="mt-4 text-sm leading-relaxed text-[#B8B8B8]">
                                    {a.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
